import { Fragment, useEffect, useState } from "react";
import clsx from "clsx";
import { translate } from "../locales/index.js";
import { DiscussitFlow } from "./DiscussitFlow.jsx";

export function ThemeFlow({ theme, hidden, onCancel }) {
  // Hidden rather than unmounted, to keep the flow where it stood.
  return (
    <div className={clsx("theme-flow", hidden && "theme-flow--hidden")}>
      <Fragment key={theme.discussit.pass}>
        <ScrollNudge />
        <tellit-player data-story-url={theme.storyUrl}></tellit-player>
      </Fragment>
      <DiscussitFlow discussit={theme.discussit} onCancel={onCancel} />
    </div>
  );
}

const SCROLL_NUDGE_UNTIL = 250;

function ScrollNudge() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const startY = window.scrollY;

    function onScroll() {
      setHidden(window.scrollY - startY > SCROLL_NUDGE_UNTIL);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="scroll-nudge" aria-hidden={hidden}>
      <p className="scroll-nudge__text">{translate("general.scroll_down")}</p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="currentColor"
        className="scroll-nudge__icon"
        aria-hidden="true"
      >
        <path d="M8.00024 12.696L4.00024 8.69603L4.93358 7.7627L8.00024 10.8127L11.0669 7.7627L12.0002 8.69603L8.00024 12.696ZM8.00024 8.69603L4.00024 4.69603L4.93358 3.7627L8.00024 6.8127L11.0669 3.7627L12.0002 4.69603L8.00024 8.69603Z" />
      </svg>
    </div>
  );
}
